// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cm-b";
export var colorBlue = "_cm-8";
export var colorDot = "_cm-0";
export var colorDotLarge = "_cm-2";
export var colorDotSmall = "_cm-1";
export var colorGreen = "_cm-7";
export var colorGrey = "_cm-3";
export var colorOrange = "_cm-5";
export var colorPink = "_cm-a";
export var colorPurple = "_cm-9";
export var colorRed = "_cm-4";
export var colorYellow = "_cm-6";